import React from 'react';
import { Box, IconButton, Paper, Slide, Stack, useMediaQuery } from '@mui/material';
import { ChevronRight as ChevronRightIcon, Clear as ClearIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
const CLOSE_ICON_WIDTH = 30;
function LeftDrawer({ children, width, top }) {
    const theme = useTheme();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const [drawerOpen, setDrawerOpen] = React.useState(isBigScreen);
    // On narrow screens (e.g. phones) the drawer must not overflow the
    // viewport: clamp to the screen width minus the toggle handle.
    const effectiveWidth = `min(${width ? width : 360}px, calc(100vw - ${CLOSE_ICON_WIDTH + 12}px))`;
    return (React.createElement(Box, { sx: { position: 'relative' } },
        React.createElement(Paper, { variant: "outlined", sx: {
                position: 'absolute',
                left: drawerOpen
                    ? `calc(${effectiveWidth} - ${CLOSE_ICON_WIDTH}px)`
                    : 0,
                top: top ? 45 : 0,
                zIndex: theme.zIndex.drawer + 1,
                backgroundColor: drawerOpen ? 'transparent' : undefined,
                border: drawerOpen ? 'none' : undefined,
            } },
            React.createElement(IconButton, { onClick: () => setDrawerOpen((e) => !e) }, drawerOpen ? React.createElement(ClearIcon, { fontSize: "small", color: "action" }) : React.createElement(ChevronRightIcon, { fontSize: "small" }))),
        React.createElement(Slide, { direction: "right", in: drawerOpen, mountOnEnter: true, unmountOnExit: true },
            React.createElement(Stack, { gap: 1, sx: {
                    position: 'fixed',
                    width: effectiveWidth,
                    top,
                    height: 'auto',
                    zIndex: theme.zIndex.drawer,
                    maxHeight: 'calc(100% - 118px)',
                    overflowY: 'auto',
                    p: 0,
                    display: 'flex',
                    flex: '1 0 auto',
                    flexDirection: 'column',
                } }, children))));
}
export default React.memo(LeftDrawer);
